import React from "react";
import styled from "styled-components";
import { NavLink as OLink } from "react-router-dom";

const DrawerModal = styled.div`
  width: 65vw;
  background-color: #f8f9fa;
  height: 100%;
  overflow: scroll;
  z-index: 200;
  display: flex;
  flex-direction: column;
  padding: 20px;
  transform: translate(-100vw);
  ${({ expanded }) => expanded && `transform: translate(0);`}
  transition: 0.5s;
`;

const BackDrop = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  transition: 0.5s;
`;

const Link = styled(OLink).attrs(() => ({
  activeStyle: {
    color: "#FF0080",
    fontWeight: "400"
  }
}))`
  text-decoration: none;
  :hover {
    color: #000;
  }
  font-family: "Roboto", sans-serif;
  color: #888888;
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: left;
  font-weight: 300;
`;

const Bar = styled.div`
  width: 90%;
  height: 1px;
  background-color: #dfe0e3;
  margin-top: 24px;
  margin-bottom: 24px;
`;

class Drawer extends React.Component {
  render() {
    const { expanded, mounted } = this.props;

    if (mounted)
      return (
        <BackDrop onClick={this.props.onToggle}>
          <DrawerModal expanded={expanded}>
            <Link to="/" exact={true}>
              Home
            </Link>
            <Link to="/getting-started" exact={true}>
              Getting Started
            </Link>
            <Bar />
            <Link to="/activity-indicator" exact={true}>
              ActivityIndicator
            </Link>
            <Link to="/alert" exact={true}>
              Alert
            </Link>
            <Link to="/text" exact={true}>
              Text
            </Link>
            <Link to="/textinput" exact={true}>
              TextInput
            </Link>
          </DrawerModal>
        </BackDrop>
      );

    return <div />;
  }
}

export default Drawer;
